import { render } from "./coPaymentInputs.vue?vue&type=template&id=4722d670&scoped=true"
import script from "./coPaymentInputs.vue?vue&type=script&lang=js"
export * from "./coPaymentInputs.vue?vue&type=script&lang=js"

import "./coPaymentInputs.vue?vue&type=style&index=0&id=4722d670&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4722d670"]])

export default __exports__